import { GAMES_MODE } from "~slices/gameTypes/constants";
export var getTwoFirstGlobalGames = function (games) {
    var globalGames = games.filter(function (game) { return game.gameMode === GAMES_MODE.GLOBAL; });
    return globalGames.slice(0, 2);
};
